export const PROFESSIONAL_ORGANIZATION_EMPLOYEES = [
    { label: '100名以下', value: 1 },
    { label: '100〜1000名', value: 2 },
    { label: '1000〜5000名', value: 3 },
    { label: '5000〜1万人', value: 4 },
    { label: '1万〜5万人', value: 5 },
    { label: '5万人〜10万人', value: 6 },
    { label: '10万人以上', value: 7 },
];
export default PROFESSIONAL_ORGANIZATION_EMPLOYEES;
